import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actions } from '../../CellphoneRecharge'
import PropTypes from 'prop-types'
import FormStep from './FormStep'
import ErrorStep from './ErrorStep'
import SuccessStep from './SuccessStep/SuccessStep'
import OperatorStep from './OperatorStep'

class RechargePhone extends Component {
  constructor (props) {
    super(props)
    this.state = {
      operatorStep: true,
      formStep: false,
      orderId: undefined,
      operatorKey: undefined
    }
    this.onChangeMobileOperator = this.onChangeMobileOperator.bind(this)
    this.resetSteps = this.resetSteps.bind(this)
    this.tryAgain = this.tryAgain.bind(this)
    this.goFormStep = this.goFormStep.bind(this)
    this.insertedMobileRecharge = this.insertedMobileRecharge.bind(this)
    this.errorInsertMobileRecharge = this.errorInsertMobileRecharge.bind(this)
    this.beforeInsertMobileRecharge = this.beforeInsertMobileRecharge.bind(this)
  }

  beforeInsertMobileRecharge () {
    this.setState({
      loadingFinalizeOrder: true
    })
  }

  insertedMobileRecharge ({ id: orderId }) {
    this.setState({
      loadingFinalizeOrder: undefined,
      operatorStep: false,
      formStep: false,
      orderId
    })
  }

  errorInsertMobileRecharge (errorMessage) {
    this.setState({
      loadingFinalizeOrder: undefined,
      errorMessage,
      operatorStep: false,
      formStep: false
    })
  }

  onChangeMobileOperator (e) {
    this.setState({
      operatorKey: e.mobileOperator
    })
  }

  resetSteps () {
    this.setState({
      operatorStep: true,
      formStep: false,
      errorMessage: undefined,
      operatorKey: undefined,
      orderId: undefined
    })
  }

  goFormStep () {
    this.setState({
      operatorStep: false,
      formStep: true,
      errorMessage: undefined
    })
  }

  tryAgain () {
    this.setState({
      operatorStep: false,
      formStep: true
    })
  }

  render () {
    return (
      <div className='item-service col-12 col-md-8 col-lg-4 px-1 mb-lg-0 mb-3'>
        {this.state.operatorStep ? (
          <OperatorStep
            operatorKey={this.state.operatorKey}
            onChangeMobileOperator={this.onChangeMobileOperator}
            nextStep={this.goFormStep}
            pointsValue={this.props.pointsValue}
          />
        ) : (
          ''
        )}
        {this.state.operatorKey ? (
          <FormStep
            operatorKey={this.state.operatorKey}
            loadingFinalizeOrder={this.state.loadingFinalizeOrder}
            insertMobileRecharge={this.props.insertMobileRecharge(
              this.beforeInsertMobileRecharge,
              this.insertedMobileRecharge,
              this.errorInsertMobileRecharge
            )}
            backStep={this.resetSteps}
            visible={this.state.formStep}
          />
        ) : (
          ''
        )}
        {(this.state.errorMessage && (
          <ErrorStep
            resetSteps={this.resetSteps}
            tryAgain={this.goFormStep}
            errorMessage={this.state.errorMessage}
            title={'Não foi possível concluir a sua transação'}
          />
        )) ||
          ''}
        {this.state.orderId ? (
          <SuccessStep
            resetSteps={this.resetSteps}
            orderId={this.state.orderId}
            tryAgain={this.tryAgain}
          />
        ) : (
          ''
        )}
      </div>
    )
  }
}

RechargePhone.propTypes = {
  insertMobileRecharge: PropTypes.func,
  pointsValue: PropTypes.string
}

const mapStateToProps = ({
  cellphoneRecharge: { errorMessage, mobileRechargeInserted },
  catalog: { currencyConfiguration }
}) => {
  return {
    errorMessage,
    mobileRechargeInserted,
    pointsValue: currencyConfiguration.pointsName
  }
}

const mapDispatchToProps = dispatch => ({
  insertMobileRecharge: (beforeInsert, successCallback, errorCallback) => (
    serviceId,
    operatorKey,
    areaCode,
    phone
  ) => {
    if (beforeInsert) beforeInsert()
    dispatch(
      actions.insertMobileRecharge(
        serviceId,
        operatorKey,
        areaCode,
        phone,
        successCallback,
        errorCallback
      )
    )
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RechargePhone)



// WEBPACK FOOTER //
// ./src/features/Services/RechargePhone/RechargePhone.js